/**
 * SuggestionChips Component
 * Clickable suggestion chips for quick actions
 */

import React from 'react';
import './SuggestionChips.css';

interface SuggestionChipsProps {
  suggestions: Array<string | { label: string; query?: string; action?: string }>;
  onSuggestionClick: (suggestion: string) => void;
}

const SuggestionChips: React.FC<SuggestionChipsProps> = ({ 
  suggestions, 
  onSuggestionClick 
}) => {
  if (!suggestions || suggestions.length === 0) return null;

  const handleClick = (suggestion: string | { label: string; query?: string; action?: string }) => {
    if (typeof suggestion === 'string') {
      onSuggestionClick(suggestion);
    } else {
      // If it's an object with query, use that; otherwise use label
      onSuggestionClick(suggestion.query || suggestion.label);
    }
  };

  return (
    <div className="suggestion-chips">
      {suggestions.map((suggestion, index) => {
        const label = typeof suggestion === 'string' ? suggestion : suggestion.label;
        
        return (
          <button
            key={index}
            className="suggestion-chip"
            onClick={() => handleClick(suggestion)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default SuggestionChips;
